import {Component, Input} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgClass, NgForOf} from "@angular/common";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {GeneralService} from "../../../../core/services/general.service";
import {ListService} from "../../../../core/services/list.service";

@Component({
  selector: 'app-change-status',
  standalone: true,
    imports: [
        FormsModule,
        NgForOf,
        ReactiveFormsModule,
        NgClass
    ],
  templateUrl: './change-status.component.html',
  styleUrl: './change-status.component.scss'
})
export class ChangeStatusComponent {
    @Input() confirmAction!: () => void;
    @Input() data: any;

    options = [
        { value: 1, label: 'Asignado' },
        { value: 2, label: 'Aceptado' },
        { value: 3, label: 'En proceso' },
        { value: 4, label: 'Finalizado' }
    ];
    public validate: boolean = false;
    public changeStatusForm : FormGroup;
    constructor(public modal:NgbModal, private fb:FormBuilder, private generalService: GeneralService, private listService: ListService) {
        this.changeStatusForm = this.fb.group ({
            id: new FormControl(0),
            assignment_status: new FormControl("", Validators.required)
        });
    }

    sendForm(){
        if (this.changeStatusForm.invalid) {
            this.validate = true;
        } else {
            this.changeStatusForm.get('id')?.setValue(this.data.id);
            this.listService.updateStatus(this.changeStatusForm.value).subscribe(
                (res: any) => {
                    if (res.error) {
                        this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    } else {
                        this.changeStatusForm.reset();
                        this.generalService.showMessage('success', res.message);
                        this.confirmAction();
                    }
                },
                (err) => {
                    this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                }
            );
        }
    }

    get assignmentStatus() {
        return this.changeStatusForm.get("assignment_status");
    }

    get currentStatusValue(): number {
        const found = this.options.find(opt => opt.label == this.data['assignments.assignment_status']);
        return found ? found.value : 0;
    }

    get filteredOptions() {
        return this.options.filter(opt => opt.value > this.currentStatusValue);
    }

}
